import { render, staticRenderFns } from "./faq-image.vue?vue&type=template&id=6bda3e18&"
import script from "./faq-image.vue?vue&type=script&lang=js&"
export * from "./faq-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports